import $ from 'jquery';
import { gsap, ScrollTrigger } from 'gsap/all';

// -----------------------------------------------------------------------------
// Components
// -----------------------------------------------------------------------------
import header        from '@components/header';
import hamburgerMenu from '@components/hamburger-menu';
import homePage      from '@components/home-page';
import hero          from '@components/hero';
import fiftyFiftyB   from '@components/fifty-fifty-b';
import blueBlock     from './components/_background/blue-block/blue-block';

// -----------------------------------------------------------------------------
// Plugins
// -----------------------------------------------------------------------------
import Animate       from '@plugins/animate';
import externalLinks from '@plugins/external-links';
import jsLinkEvent   from '@plugins/js-link-event';

window.$ = $;

const initializer = {
  components: [
    ['.header', header],
    ['.hamburger-menu', hamburgerMenu],
    ['.js-home-page-carousel-slides', homePage],
    ['.hero', hero],
    ['.js-caption', fiftyFiftyB],
    ['.blue-block', blueBlock]
  ],
  plugins: [
    externalLinks,
    jsLinkEvent
  ]
};

class FalcoreJS {

  constructor(initializer) {
    this.initializer = initializer;
    this.init();
  }

  init() {

    // Initialize all plugins
    this.callAll(this.initializer.plugins);

    // Initialize animations
    new Animate('[data-animation]');

    // Initialize all components
    this.callAll(this.initializer.components, this.initComponent);

    gsap.registerPlugin(ScrollTrigger);

    const movementBaseline = 1000;

    gsap.utils.toArray('[data-speed]').forEach(el => {

      gsap.to(el, {
        y: (+el.getAttribute('data-speed') - 1) * -movementBaseline,
        ease: 'none',
        scrollTrigger: {
          trigger: el,
          scrub: 0.3
        }
      });

    });
  }

  callAll(items, fn = (fn) => fn()) {
    items.forEach(fn);
  }

  initComponent([selector, handler]) {
    const $component = $(selector);

    if (!$component.length) {
      return null;
    }

    return $component.each((i, item) => {
      return handler(item);
    });
  }
}

(($) => {

  // Document Ready
  $(() => {
    new FalcoreJS(initializer);
  });

})($);
